import mixpanel from 'mixpanel-browser';

import { config } from '@mytaxi/config-store';

export const initializeMixpanel = (): void => {
    mixpanel.init(config.getItem('mixpanelToken'), {
        autocapture: {
            pageview: 'full-url',
            click: false,
            dead_click: true,
            input: false,
            rage_click: true,
            scroll: true,
            submit: true,
            capture_text_content: false,
        },
        track_pageview: true,
        record_heatmap_data: true,
        record_sessions_percent: 100,
        api_host: 'https://api-eu.mixpanel.com',
        debug: config.getItem('environment') !== 'live',
    });
};
